import { render } from "./giftshowList.vue?vue&type=template&id=b36b1902&scoped=true"
import script from "./giftshowList.vue?vue&type=script&lang=js"
export * from "./giftshowList.vue?vue&type=script&lang=js"

import "./giftshowList.vue?vue&type=style&index=0&id=b36b1902&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b36b1902"]])

export default __exports__